import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html'
})
export class OrganizationComponent implements OnInit {
  @ViewChild('addDataModal') public addDataModal: ModalDirective;
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild('updateDataModal') public updateDataModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    { typeCode: 'admin', permission: 'rwmd' },
    { typeCode: 'staff', permission: 'r' }
  ]
  dataList = [];
  departments = [];
  newForm = {
    name: '',
    branch_name: '',
    address: '',
    email: '',
    contact_no: '',
    contact_no_2: '',
    website: '',
    attachment: '',
    stamp: '',
    signature: ''
  }

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService: ConstantService, private apiService: ApiService) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex: 0,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer: DeleteButtonRendererComponent
    };

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 80, filter: false },
      {
        headerName: 'Logo', field: 'attachment', width: 150,
        cellRenderer: params => { return params.data.attachment ? '<img src="' + params.data.attachment + '" width="100px">' : '' },
        colId: 'attachment', filter: false, resizable: true, sortable: false, cellClass: ['text-center'], columnGroupShow: 'closed'
      },
      { headerName: 'Organization', field: 'name', width: 150 },
      { headerName: 'Branch Name', field: 'branch_name', width: 100 },
      { headerName: 'Address', field: 'address', width: 250 },
      { headerName: 'Email Id', field: 'email', width: 100 },
      { headerName: 'Contact No', field: 'contact_no', width: 100 },
      { headerName: 'Contact No 2', field: 'contact_no_2', width: 100 },
      { headerName: 'Website', field: 'Website', width: 200 },
      {
        headerName: 'Stamp', field: 'stamp', width: 150,
        cellRenderer: params => { return params.data.stamp ? '<img src="' + params.data.stamp + '" width="100px">' : '' },
        colId: 'stamp', filter: false, resizable: true, sortable: false, cellClass: ['text-center'], columnGroupShow: 'closed'
      }
    ];

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params', width: 60, filter: false, resizable: true, sortable: false, cellClass: ['text-center'] },
        { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1', width: 60, filter: false, resizable: true, sortable: false, cellClass: ['text-center'] },
      )
    }
  }

  ngOnInit(): void {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listData();
  }
  listData() {
    this.apiService.getData('organization').then((resp: []) => {
      this.dataList = resp;
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if (userData.action === 'edit') {
      this.newForm = _.clone(this.selectedData);

      this.updateDataModal.show();
    }
    if (userData.action === 'delete') {
      this.deleteDataModal.show();
    }


  }

  savenewForm() {
    // this.newProfileForm.sectors = ((this.selectedItems).map(item => item.item_text)).join(',');

    // let duplicateRecord = this.checkForDuplicates(this.newForm);
    // if(duplicateRecord) {
    //   this.alert.type = 'danger';
    //   this.alert.msg = 'Data already saved';
    //   setTimeout(() => {
    //     this.addDataModal.hide();
    //   this.alert.type = '';
    //     this.alert.msg = '';
    //   }, 2000)
    // } else {

    this.apiService.addData('organization', this.newForm).subscribe((resp) => {
      console.log(resp);
      this.resetForm();
      this.listData();
      this.alert.msg = 'Data has been successfully created.';
      setTimeout(() => {
        this.addDataModal.hide();
        this.alert.msg = '';
      }, 2000)
    })

    // }


  }

  selectUserType(type) {
    if (type !== 'department') {
    }
  }
  resetForm() {
    this.newForm = {
      name: '',
      branch_name: '',
      address: '',
      email: '',
      contact_no: '',
      contact_no_2: '',
      website: '',
      attachment: '',
      stamp: '',
      signature: ''
    }
  }

  updateProfile() {
    let payload = {
      name: this.newForm.name,
      branch_name: this.newForm.branch_name,
      address: this.newForm.address,
      email: this.newForm.email,
      contact_no: this.newForm.contact_no,
      contact_no_2: this.newForm.contact_no_2,
      website: this.newForm.website,
    };
    if (this.newForm.attachment && (this.newForm.attachment).split(',').length > 1) {
      payload['attachment'] = this.newForm.attachment;
    }
    if (this.newForm.stamp && (this.newForm.stamp).split(',').length > 1) {
      payload['stamp'] = this.newForm.stamp;
    }
    let that = this;
    this.apiService.updateDetail('organization', 'srl_no', this.selectedData.srl_no, payload).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listData();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateDataModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.dataList, (item) => {
      return (item.name).toLowerCase() === (data.name).toLowerCase();
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }

  }


  deleteData() {
    this.apiService.deleteDetail('organization', 'srl_no', [this.selectedData.srl_no]).subscribe((resp) => {
      this.listData();
      setTimeout(() => {
        this.deleteDataModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }


  fileChange(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    let that = this;
    reader.readAsDataURL(file);
    reader.onload = () => {
      that.newForm.attachment = reader.result as string;
    };
  }
  fileChangeStamp(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    let that = this;
    reader.readAsDataURL(file);
    reader.onload = () => {
      that.newForm.stamp = reader.result as string;
    };
  }
  fileChangeSign(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    let that = this;
    reader.readAsDataURL(file);
    reader.onload = () => {
      that.newForm.signature = reader.result as string;
    };
  }
}
